import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { Link } from '@cp/ds/src/components/link';
import AppStoreSvg from '../../../assets/shapes/appStore.svg';
import PlayMarketSvg from '../../../assets/shapes/playMarket.svg';
import { MobileAppLinksProps } from './model';

export const MobileAppLinks: React.FC<MobileAppLinksProps> = ({ sx, ...props }) => {
  const isMobile = useIsMobile();

  return (
    <Stack
      direction="row"
      spacing={1.2}
      {...props}
      sx={mergeSx({ justifyContent: { xs: 'flex-start', md: 'center' }, alignItems: 'center' }, sx)}
    >
      <Link
        external
        href={isMobile ? 'itms-apps://apps.apple.com/ru/app/youhelp/id1536935575' : 'https://apps.apple.com/ru/app/youhelp/id1536935575'}
        sx={{ display: 'flex', alignItems: 'center' }}
        underline={false}
      >
        <AppStoreSvg />
      </Link>
      <Link
        external
        href={isMobile ? 'market://details?id=ru.youhelp.app' : 'https://play.google.com/store/apps/details?id=ru.youhelp.app'}
        sx={{ display: 'flex', alignItems: 'center' }}
        underline={false}
      >
        <PlayMarketSvg />
      </Link>
    </Stack>
  );
};

export default MobileAppLinks;
